import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import InfoIcon from '@/images/Info.svg';
import { theme } from '@de-id/ui-components';
import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';

const FieldLabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

const Label = styled.span`
    color: ${theme.colors.secondary.main};
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.28px;
`;

const OptionalLabel = styled.span`
    color: ${theme.colors.black[700]};
    font-family: Manrope;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.28px;
`;

interface Props {
    label: string;
    optional?: boolean;
    tooltip?: string;
}

export const FieldLabel = ({ label, optional, tooltip }: Props) => {
    return (
        <FieldLabelContainer>
            <Label>{label}</Label>
            {optional && <OptionalLabel>(optional)</OptionalLabel>}

            {tooltip && (
                <Tooltip
                    title={tooltip}
                    placement="top"
                    slotProps={{
                        tooltip: { sx: { backgroundColor: theme.colors.secondary[900], padding: '8px', fontSize: '14px' } },
                    }}>
                    <MaskedIcon src={InfoIcon} size="12px" />
                </Tooltip>
            )}
        </FieldLabelContainer>
    );
};
